import { siteData } from 'routers/routes.data';

import { calcMobileMenuBarConst } from 'utils/menu/mobileUtil';
import { getPageByKey } from 'utils/menu/routePageUtil';

export const VIEW_MOBILE = '?view=mobile';

const mobileMenuSource = siteData.menu_mobile;

/**
 * site.json의 menu_mobile 설정을 기준으로 모바일 메뉴바 상수를 생성합니다.
 */
export const mobileMenuBarConst = Object.keys(mobileMenuSource).map((key) => {
  const pageKeys = mobileMenuSource[key];
  const pages = pageKeys
    .map((pageKey) => getPageByKey(pageKey))
    .filter(Boolean);

  // 첫 번째 페이지의 경로를 대메뉴 경로로 사용
  const mainPath = pages.length > 0 ? pages[0].path + VIEW_MOBILE : '#';

  return {
    title: key,
    path: mainPath,
    content: calcMobileMenuBarConst(pages, VIEW_MOBILE),
  };
});
